import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { useSubscriptionStore } from '../../stores/subscriptionStore';
import { useAuthStore } from '../../stores/authStore';
import toast from 'react-hot-toast';

export default function SubscriptionSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { fetchSubscriptionStatus, plan, status } = useSubscriptionStore();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    const finalizeSubscription = async () => {
      console.log('SubscriptionSuccess: Finalizing...');
      try {
        const { user } = useAuthStore.getState();
        if (user?.id) {
          const toastId = 'status-check';
          toast.loading('Weryfikowanie statusu subskrypcji...', { id: toastId });
          
          await fetchSubscriptionStatus(user.id);
          
          await new Promise(resolve => setTimeout(resolve, 500));

          const finalPlan = useSubscriptionStore.getState().plan;
          const finalStatus = useSubscriptionStore.getState().status;

          console.log(`[SubscriptionSuccess] Final check: Plan='${finalPlan}', Status='${finalStatus}'`);

          if (finalPlan === 'premium' && finalStatus === 'active') {
             toast.success('Subskrypcja Premium jest aktywna!', { id: toastId });
          } else {
              toast.error(`Nie udało się potwierdzić statusu Premium (Plan: ${finalPlan}, Status: ${finalStatus}). Skontaktuj się z pomocą.`, { id: toastId });
          }
        } else {
            console.warn('SubscriptionSuccess: User ID not found in AuthStore');
            toast.error('Błąd użytkownika. Spróbuj odświeżyć stronę.');
        }

        setTimeout(() => navigate('/dashboard'), 4000);

      } catch (error) {
        console.error('Error finalizing subscription:', error);
        toast.error('Wystąpił błąd podczas finalizowania subskrypcji.');
        setTimeout(() => navigate('/dashboard'), 4000);
      }
    };

    if (sessionId) {
      finalizeSubscription();
    } else {
      console.warn('SubscriptionSuccess: No session_id found in URL');
      navigate('/dashboard');
    }
  }, [sessionId, navigate, fetchSubscriptionStatus, plan, status]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center"
      >
        <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-6" />
        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          Dziękujemy za subskrypcję!
        </h1>
        <p className="text-gray-600 mb-6">
          Płatność zakończona pomyślnie. Sprawdzanie statusu Twojego konta Premium...
        </p>
        <div className="animate-pulse">
          <div className="w-8 h-8 border-4 border-purple-600 border-t-transparent rounded-full mx-auto animate-spin" />
        </div>
      </motion.div>
    </div>
  );
}
